import React from 'react';

function Navbar({ onNavigate }) {
    return (
        <nav className="navbar">
            <ul className="navbar-list">
                <li className="navbar-item">
                    <button className="navbar-link" onClick={() => onNavigate('about')}>Sobre mí</button>
                </li>
                <li className="navbar-item">
                    <button className="navbar-link" onClick={() => onNavigate('resume')}>Educación</button>
                </li>
                <li className="navbar-item">
                    <button className="navbar-link" onClick={() => onNavigate('services')}>Experiencia</button>
                </li>
                <li className="navbar-item">
                    <button className="navbar-link" onClick={() => onNavigate('testimonials')}>Portafolio</button>
                </li>
                <li className="navbar-item">
                    <button className="navbar-link" onClick={() => onNavigate('contact')}>Proyectos</button>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
